export default "__VITE_ASSET__WQfoSlEN__"